import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-group row col-lg-8 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 col-form-label" }, "Create For Feature", -1)
const _hoisted_3 = { class: "input-group col-lg-9" }
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = {
  key: 0,
  class: "col-2"
}
const _hoisted_6 = { class: "mx-auto mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_table = _resolveComponent("app-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_card, {
      label: "Function",
      classes: "pb-0"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_app_button, {
            name: "Create",
            size: "md",
            theme: "info",
            icon: "fa-plus",
            to: {
                        name: _ctx.ROUTE_NAME_PROMOTION.CODE.ADD,
                        query: { feature: _ctx.InjectionFeature.AddChips, data: 0 }
                    }
          }, null, 8, ["to"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_app_select, {
                options: _ctx.Options.features.filter(f => f.value != _ctx.InjectionFeature.AddChips),
                modelValue: _ctx.featureId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.featureId) = $event)),
                modelModifiers: { number: true }
              }, null, 8, ["options", "modelValue"])
            ]),
            (_ctx.featureId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_app_button, {
                    tooltip: "Choose",
                    theme: "info",
                    icon: "fa-shipping-fast",
                    to: _ctx.getRewardRouteToIndexPage(_ctx.featureId)
                  }, null, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_app_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_table, {
          columns: _ctx.table.columns,
          rows: _ctx.list,
          total: _ctx.total,
          offset: _ctx.query.offset,
          limit: _ctx.query.limit,
          actions: _ctx.table.actions,
          onRefreshData: _ctx.fetchList
        }, null, 8, ["columns", "rows", "total", "offset", "limit", "actions", "onRefreshData"])
      ]),
      _: 1
    })
  ], 64))
}